<script>
export default
{
    name: 'demo-video',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='demo-video'>
                <div class='play-btn' on-click={this.watchVideoClicked} ref='playVideoButton'>
                    <inline-svg class='icon' src={require('@/assets/img/play-arrow.svg')} />
                    Regarder la vidéo de présentation
                </div>
                <video class='player' ref='video' on-click={this.onVideoClicked}>
                    <source src="https://static.app-maville.com/find/solution_demo" />
                </video>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            playVideo: false
        }
    },

    computed:
    {
    },
    
    watch:
    {
        playVideo ()
        {
            if (this.playVideo)
            {
                this.$refs.playVideoButton.style.display = 'none'
                this.$refs.video.play()
            }
            else this.$refs.video.pause()
        }
    },

    methods:
    {
        watchVideoClicked ()
        {
            this.playVideo = true
        },

        onVideoClicked ()
        {
            this.playVideo = !this.playVideo
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.demo-video
{
    width: -webkit-fill-available;
    display: flex;
    justify-content: center;
    align-items: center;

    .play-btn
    {
        position: absolute;
        background-color: var(--theme-accent-color);
        color: white;
        fill: white;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px;
        border-radius: 6px;
        z-index: 1;
        cursor: pointer;
        font-size: 16px;

        .OnLargeMobile({ font-size: 20px; });
        .OnDesktop({ font-size: 25px; });

        .icon
        {
            fill: inherit;
            width: 25px;
            height: 25px;
            margin-right: 10px;
        }
    }

    .player
    {
        border-radius: 10px;
        width: 95%;
        max-width: 800px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/DemoVideo.vue